import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Services from "@/pages/Services";
import Pricing from "@/pages/Pricing";
import Roles from "@/pages/Roles";
import FAQPage from "@/pages/FAQPage";
import Contact from "@/pages/Contact";
import WhoWeAre from "@/pages/WhoWeAre";
import ManagedTeams from "@/pages/ManagedTeams";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/services" element={<Services />} />
            <Route path="/managed-teams" element={<ManagedTeams />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/roles" element={<Roles />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
